module.exports = __webpack_public_path__ + "static/media/reduce-arrows.f171d63b.svg";